import React from 'react';
import { Box, IconButton } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { Card, Typography } from '../../../ui-kit';
import {
    CreateWarehouseCardMutation,
    CreateWarehouseCardMutationVariables,
    useCreateWarehouseCardMutation,
} from '../../../generated/graphql';
import WarehouseCardForm from '../../warehouse/components/WarehouseCards/WarehouseCardsForm';
import { useWarehousesScope } from '../../warehouse/providers/WarehouseScopeProvider';
import { WarehouseCardFormValues } from '../../warehouse/components/WarehouseCards';
import { usePriceService } from '../../../utils/hooks/priceService';
import { getPriceUpdateArgs } from '../../warehouse/components/WarehouseCards/utils';

interface DeliveryListCreateWarehouseFormProps {
    onClose(): void;
    dialogName: string;
    requiredWarehouseIds: string[];
    onMutationFinished(result: CreateWarehouseCardMutation): void;
    initialValues?: Partial<WarehouseCardFormValues>;
}

const DeliveryListCreateWarehouseForm = ({
    onClose,
    dialogName,
    requiredWarehouseIds,
    onMutationFinished,
    initialValues,
}: DeliveryListCreateWarehouseFormProps) => {
    const { t } = useTranslation();
    const { currentWarehouseId } = useWarehousesScope();
    const { priceService } = usePriceService();

    const [runMutation] = useCreateWarehouseCardMutation({ onCompleted: onMutationFinished });
    const onSubmit = async ({
        name,
        warehouseIds,
        categoryId,
        convertedQuanitity,
        convertedUnit,
        storageUnitId: storagUnitId,
        taxId,
        sku,
        priceWithoutVat,
    }: WarehouseCardFormValues) => {
        const priceUpdateArgs = getPriceUpdateArgs({ priceWithoutVat, warehouseIds, priceService });

        const variables: CreateWarehouseCardMutationVariables = {
            data: {
                name,
                sku,
                taxId,
                warehouseIds,
                storageUnit: storagUnitId,
                convertedAmount: convertedQuanitity ? parseFloat(convertedQuanitity.toString()) : null,
                conversionUnit: convertedUnit,
                stockCardCategoryId: categoryId,
            },
            priceUpdateArgs,
        };

        await runMutation({ variables });
    };

    return (
        <Card style={{ height: '100%' }}>
            <Box px={3} py={2}>
                <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
                    <ArrowBack />
                </IconButton>
                <Box mb={2} />
                <Typography variant='h6' component='h1'>{dialogName}</Typography>
                <WarehouseCardForm
                    requiredWarehouseIds={requiredWarehouseIds}
                    onSubmit={onSubmit}
                    buttonText={t('Create warehouse card')}
                    dialogName={dialogName}
                    currentWarehouseId={currentWarehouseId as string}
                    onClose={onClose}
                    initialValues={initialValues}
                />
            </Box>
        </Card>
    );
};

export default DeliveryListCreateWarehouseForm;
